import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { AnimatePresence, motion } from 'framer-motion'
import { useRef } from 'react'

import MobileMenuIcon from '../assets/icons/menu-icon.svg'
import DownArrow from '../assets/icons/down-arrow.svg'
import CloseIcon from '../assets/icons/close-icon_black.svg'
import OpenIcon from '../assets/icons/open-icon.svg'

const navigationList = [
  { name: '회사소개', path: '/skills' },
  { name: '포트폴리오', path: '/portfolio' },
  { name: '솔루션', path: '/hugcare' },
  { name: '채용공고', path: '/recruit' },
  { name: '문의하기', path: '/contact/qnas/intro' },
]
const contactList = [
  { name: '1분 문답', path: '/contact/qnas/intro' },
  { name: '간편 문의', path: '/contact/inquiry' },
]
const aboutList = [
  { name: '역량', path: '/skills' },
  { name: '오시는 길', path: '/about/location' },
]
const solutionList = [
  { name: '허그케어', path: '/hugcare' },
  { name: '스카이온', path: '' },
]

export default function Header() {
  const [isHovered, setIsHovered] = useState()
  // const { scrollYProgress } = useScroll()
  const location = useLocation()
  // const navigate = useNavigate()

  // header selectAnimation
  const [selectedTab, setSelectedTab] = useState('/')
  // header progressbar
  const [scrollYProgress, setScrollYProgress] = useState(0)

  useEffect(() => {
    if (location.pathname === '/skills') {
      setSelectedTab(location.pathname + location.search)
    } else {
      setSelectedTab(location.pathname)
    }
    window.onscroll = function () {
      scrollEventListener()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  function scrollEventListener() {
    if (document.documentElement.scrollHeight <= document.documentElement.clientHeight)
      setScrollYProgress(0)
    else
      setScrollYProgress(
        document.documentElement.scrollTop /
          (document.documentElement.scrollHeight - document.documentElement.clientHeight)
      )
  }

  const [isMobileClick, setIsMobileClick] = useState(false)
  const [isAboutClick, setIsAboutClick] = useState(false)
  const [isSolutionClick, setIsSolutionClick] = useState(false)
  const [isContactClick, setIsContactClick] = useState(false)

  const menuRef = useRef()

  useEffect(() => {
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setIsMobileClick(false)
        setIsAboutClick(false)
        setIsContactClick(false)
        setIsSolutionClick(false)
      }
    }

    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [menuRef])
  return (
    <div ref={menuRef}>
      <div className='bg-white border-b border-sk-border w-full h-[60px] fixed z-[200]'>
        <div className='container w-full h-full px-20 mx-auto'>
          <div className='flex items-center justify-between h-full gap-64 pl-10 select-none sm:px-10'>
            <Link to='/' className='w-[75px]'>
              <img
                src={require('assets/logos/logo-header.png')}
                alt=''
                onClick={() => {
                  setIsMobileClick(false)
                  setIsAboutClick(false)
                  setIsContactClick(false)
                  setIsSolutionClick(false)
                }}
              ></img>
            </Link>
            {/* 헤더 모바일 햄버거 */}
            <button
              className='items-center w-32 h-32 md:hidden'
              onClick={() => {
                setIsMobileClick((prev) => !prev)
                setIsAboutClick(false)
                setIsContactClick(false)
                setIsSolutionClick(false)
              }}
            >
              <img
                src={`${isMobileClick ? CloseIcon : MobileMenuIcon}`}
                className={`items-center ${
                  isMobileClick
                    ? 'transition-all duration-300 rotate-180 '
                    : 'transition-all rotate-0 duration-300'
                }`}
                alt=''
              />
            </button>

            {/* 헤더 메뉴 리스트 */}
            <div className='relative items-center hidden h-full cursor-pointer md:gap-8 md:flex lg:gap-48'>
              {navigationList.map((nav, index) => (
                <Link
                  key={index}
                  to={nav.path}
                  className={`relative h-full flex items-center mx-16 shrink-0 max-md:hidden text-sk-default
                  ${nav.path === selectedTab ? 'text-body1-semibold ' : 'text-body1-medium '}
                  ${index === 4 ? 'group flex flex-col items-center justify-center' : null}
                  ${index === 0 ? 'group flex flex-col items-center justify-center' : null}
                  ${index === 2 ? 'group flex flex-col items-center justify-center' : null}
                  `}
                  onMouseEnter={() => setIsHovered(index)}
                  onMouseLeave={() => setIsHovered()}
                >
                  <p>{nav.name}</p>

                  <motion.div
                    initial={false}
                    animate={{ scaleX: isHovered === index ? 1 : 0 }}
                    className='absolute bottom-10 w-full left-0 h-[2px] bg-sk-default border border-sk-black rounded-[100px]'
                  ></motion.div>
                  <AnimatePresence>
                    {selectedTab.startsWith(nav.path) ? (
                      <motion.div
                        key={nav.path}
                        initial={{ scaleX: 0 }}
                        animate={{ scaleX: 1 }}
                        exit={{ scaleX: 0 }}
                        className='absolute bottom-10 w-full left-0 h-[2px] bg-sk-default border border-sk-black rounded-[100px]'
                      ></motion.div>
                    ) : null}
                  </AnimatePresence>
                  {index === 0 && (
                    <div className='bg-sk-white absolute h-0 group-hover:h-[116px] transition-all ease-in-out duration-200 top-[70px] w-100 overflow-hidden shadow-emphasize'>
                      <div className='flex flex-col items-center gap-20 py-16 cursor-pointer'>
                        {aboutList.map((aboutItem, index) => (
                          <Link
                            key={index}
                            to={aboutItem.path}
                            className={`relative flex items-center text-sk-default ${
                              aboutItem.path === selectedTab
                                ? 'text-body1-semibold'
                                : 'text-body1-medium'
                            }
                    `}
                          >
                            <p className='py-4 hover:text-body1-semibold'>{aboutItem.name}</p>
                            <AnimatePresence>
                              {selectedTab === aboutItem.path ? (
                                <motion.div
                                  key={aboutItem.path}
                                  initial={{ scaleX: 0 }}
                                  animate={{ scaleX: 1 }}
                                  exit={{ scaleX: 0 }}
                                  className='absolute bottom-0 w-full left-0 h-[2px] bg-sk-default border border-sk-black rounded-[100px]'
                                ></motion.div>
                              ) : null}
                            </AnimatePresence>
                          </Link>
                        ))}
                      </div>
                    </div>
                  )}
                  {index === 2 && (
                    <div className='bg-sk-white absolute h-0 group-hover:h-[116px] transition-all ease-in-out duration-200 top-[70px] w-[110px] overflow-hidden shadow-emphasize'>
                      <div className='flex flex-col items-center gap-20 py-16 cursor-pointer'>
                        {solutionList.map((solutionItem, index) => (
                          <Link
                            key={index}
                            to={solutionItem.path}
                            target={solutionItem.target}
                            className={`relative flex items-center gap-2
                              ${index === 0 ? 'text-sk-hugcare' : 'text-sk-default'}
                              ${
                                solutionItem.path === selectedTab
                                  ? 'text-body1-semibold'
                                  : 'text-body1-medium'
                              }
                    `}
                          >
                            <p
                              className='py-4 hover:text-body1-semibold'
                              onClick={() => {
                                index === 1 && window.open('https://skyon.kr', '_blank')
                              }}
                            >
                              {solutionItem.name}
                            </p>
                            {index === 1 && <img src={OpenIcon} alt='' />}
                            <AnimatePresence>
                              {selectedTab === solutionItem.path ? (
                                <motion.div
                                  key={solutionItem.path}
                                  initial={{ scaleX: 0 }}
                                  animate={{ scaleX: 1 }}
                                  exit={{ scaleX: 0 }}
                                  className='absolute bottom-0 w-full left-0 h-[2px] bg-sk-default border border-sk-black rounded-[100px]'
                                ></motion.div>
                              ) : null}
                            </AnimatePresence>
                          </Link>
                        ))}
                      </div>
                    </div>
                  )}
                  {index === 4 && (
                    <div className='bg-sk-white absolute h-0 group-hover:h-[116px] transition-all ease-in-out duration-200 top-[70px] w-100 overflow-hidden shadow-emphasize'>
                      <div className='flex flex-col items-center gap-20 py-16 cursor-pointer'>
                        {contactList.map((contactItem, index) => (
                          <Link
                            key={index}
                            to={contactItem.path}
                            className={`relative flex items-center text-sk-default ${
                              contactItem.path === selectedTab
                                ? 'text-body1-semibold'
                                : 'text-body1-medium'
                            }
                    `}
                          >
                            <p className='py-4 hover:text-body1-semibold'>{contactItem.name}</p>
                            <AnimatePresence>
                              {selectedTab.includes(contactItem.path) ? (
                                <motion.div
                                  key={contactItem.path}
                                  initial={{ scaleX: 0 }}
                                  animate={{ scaleX: 1 }}
                                  exit={{ scaleX: 0 }}
                                  className='absolute bottom-0 w-full left-0 h-[2px] bg-sk-default border border-sk-black rounded-[100px]'
                                ></motion.div>
                              ) : null}
                            </AnimatePresence>
                          </Link>
                        ))}
                      </div>
                    </div>
                  )}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* 모바일 메뉴 리스트 */}
      <div
        className={`md:hidden fixed top-60 flex flex-col items-start transition-all overflow-hidden ease-in-out duration-300 bg-sk-white z-[200]  w-full
          ${
            !isMobileClick
              ? 'h-0 opacity-0'
              : isContactClick && isAboutClick && isSolutionClick
              ? `h-[660px] opacity-100`
              : isContactClick && isAboutClick
              ? `h-[540px] opacity-100`
              : isAboutClick && isSolutionClick
              ? `h-[540px] opacity-100`
              : isSolutionClick && isContactClick
              ? `h-[540px] opacity-100`
              : isContactClick
              ? `h-[420px] opacity-100`
              : isAboutClick
              ? `h-[420px] opacity-100`
              : isSolutionClick
              ? `h-[420px] opacity-100`
              : `h-[300px] opacity-100`
          }
          `}
      >
        {navigationList.map((nav, index) => (
          <Link
            key={index}
            to={`${
              index === 0
                ? selectedTab
                : index === 4
                ? selectedTab
                : index === 2
                ? selectedTab
                : nav.path
            }`}
            className={`flex items-center h-60 ease-in-out duration-300 transition-all w-full hover:bg-neutral-99 px-36
              ${nav.path === selectedTab ? 'text-body1-semibold ' : 'text-body1-medium '}
              ${index === 4 ? 'relative justify-between w-full' : null}
              ${index === 4 && isContactClick ? 'mb-[120px] bg-neutral-99' : null}
              ${index === 0 ? 'relative justify-between w-full' : null}
              ${index === 0 && isAboutClick ? 'mb-[120px] bg-neutral-99' : null}
              ${index === 2 ? 'relative justify-between w-full' : null}
              ${index === 2 && isSolutionClick ? 'mb-[120px] bg-neutral-99' : null}
              `}
            // onClick={() => onClickMenu(nav)}
            onClick={() => {
              index === 4
                ? setIsContactClick((prev) => !prev)
                : index === 0
                ? setIsAboutClick((prev) => !prev)
                : index === 2
                ? setIsSolutionClick((prev) => !prev)
                : setIsMobileClick((prev) => !prev)
            }}
          >
            <p>{nav.name}</p>
            {index === 0 && (
              <button>
                <img
                  className={`${
                    isAboutClick
                      ? 'transition-all duration-300 rotate-180'
                      : 'transition-all rotate-0 duration-300'
                  }`}
                  src={DownArrow}
                  alt=''
                />
              </button>
            )}
            {index === 0 && (
              <div
                className={`bg-sk-white absolute transition-all ease-in-out duration-300 top-60 w-full overflow-hidden ${
                  isAboutClick ? 'h-[120px]' : 'h-0'
                }`}
              >
                <div className='flex flex-col items-start cursor-pointer'>
                  {aboutList.map((aboutItem, index) => (
                    <Link
                      key={index}
                      to={aboutItem.path}
                      className={`flex items-center text-sk-default w-full px-10 py-[18px] hover:text-body1-semibold ${
                        aboutItem.path === selectedTab ? 'text-body1-semibold' : 'text-body1-medium'
                      }
                    `}
                      onClick={() => {
                        setIsMobileClick((prev) => !prev)
                        setIsContactClick(false)
                        setIsSolutionClick(false)
                      }}
                    >
                      {aboutItem.name}
                    </Link>
                  ))}
                </div>
              </div>
            )}

            {index === 2 && (
              <button>
                <img
                  className={`${
                    isSolutionClick
                      ? 'transition-all duration-300 rotate-180'
                      : 'transition-all rotate-0 duration-300'
                  }`}
                  src={DownArrow}
                  alt=''
                />
              </button>
            )}
            {index === 2 && (
              <div
                className={`bg-sk-white absolute transition-all ease-in-out duration-300 top-60 w-full overflow-hidden ${
                  isSolutionClick ? 'h-[120px]' : 'h-0'
                }`}
              >
                <div className='flex flex-col items-start cursor-pointer'>
                  {solutionList.map((solutionItem, index) => (
                    <Link
                      key={index}
                      to={solutionItem.path}
                      className={`flex items-center w-full px-10 py-[18px] hover:text-body1-semibold gap-2 
                        ${index === 0 ? 'text-sk-hugcare' : 'text-sk-default'}
                        ${
                          solutionItem.path === selectedTab
                            ? 'text-body1-semibold'
                            : 'text-body1-medium'
                        }
                    `}
                      onClick={() => {
                        setIsMobileClick((prev) => !prev)
                        setIsContactClick(false)
                        setIsAboutClick(false)
                        index === 1 && window.open('https://skyon.kr', '_blank')
                      }}
                    >
                      {solutionItem.name}
                      {index === 1 && <img src={OpenIcon} alt='' />}
                    </Link>
                  ))}
                </div>
              </div>
            )}

            {index === 4 && (
              <button>
                <img
                  className={`${
                    isContactClick
                      ? 'transition-all duration-300 rotate-180'
                      : 'transition-all rotate-0 duration-300'
                  }`}
                  src={DownArrow}
                  alt=''
                />
              </button>
            )}
            {index === 4 && (
              <div
                className={`bg-sk-white absolute transition-all ease-in-out duration-300 w-full overflow-hidden top-60 ${
                  isContactClick ? 'h-[120px]' : 'h-0'
                }`}
              >
                <div className='flex flex-col items-start w-full cursor-pointer'>
                  {contactList.map((contactItem, index) => (
                    <Link
                      key={index}
                      to={contactItem.path}
                      className={`flex items-center text-sk-default w-full px-10 py-[18px] hover:text-body1-semibold ${
                        contactItem.path === selectedTab
                          ? 'text-body1-semibold'
                          : 'text-body1-medium'
                      }
                    `}
                      onClick={() => {
                        setIsMobileClick((prev) => !prev)
                        setIsAboutClick(false)
                        setIsSolutionClick(false)
                      }}
                    >
                      {contactItem.name}
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </Link>
        ))}
      </div>
      {selectedTab !== '/contact/qnas' && (
        <motion.div
          className='fixed z-[150] mt-[60px] w-full h-[3px] bg-gradient-to-r from-[#FFFFFF] to-[#000000] rounded-full origin-left transition-all duration-300 ease-out '
          style={{ scaleX: scrollYProgress }}
        ></motion.div>
      )}
    </div>
  )
}
